<template>
  <v-row>
    <!-- Start Blog Area  -->
    <v-col
      lg="4"
      md="4"
      sm="6"
      cols="12"
      v-for="(item, i) in blogContent"
      :key="i"
    >
      <div class="blog blog-style--1">
        <div class="thumbnail">
          <router-link :to="{ path: `/blog/${item.slug}` }">
            <img class="w-100" :src="item.src" alt="Blog Images" />
          </router-link>
        </div>
        <div class="content">
          <p class="blogtype">{{ item.meta }}</p>
          <h4 class="heading-title">
            <router-link :to="{ path: `/blog/${item.slug}` }">{{ item.title }}</router-link>
          </h4>
          <div class="blog-btn">
            <router-link :to="{ path: `/blog/${item.slug}` }" class="rn-btn white--text">
              Leer más
            </router-link>
          </div>
        </div>
      </div>
    </v-col>
    <!-- End Blog Area  -->
  </v-row>
</template>

<script>
  export default {
    props: ['posts'],
    data() {
      return {
        blogContent: this.posts,
      };
    },
  };
</script>
